export class BulkTabletsTransactionRow{
  mac?: string
  result?: boolean
  status?: string

  constructor(params?: Partial<BulkTabletsTransactionRow>) {
    Object.assign(this, params)
  }
}
